export const slugifyPathSegment = (value = '') =>
  String(value)
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9-]/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')

export const buildFundraiserPagePath = (
  organizationName,
  campaignSlug,
  { placeholder = false } = {}
) => {
  const orgSegment = slugifyPathSegment(organizationName)
  const campaignSegment = slugifyPathSegment(campaignSlug)

  if (!orgSegment) {
    return placeholder ? '/{organization}/fundraisers/campaign-slug' : ''
  }

  return `/${orgSegment}/fundraisers/${campaignSegment || (placeholder ? 'campaign-slug' : '')}`
}
